<template>
  <div class="container">
    <div class="row m-2 pt-4">
      <div class="col d-flex justify-content-center">
        <h2>Si us plau fes login a Microsoft Identity Platform</h2>
      </div>
    </div>
    <div class="row">
      <div class="col d-flex justify-content-center">
        <button class="btn btn-dark btn-block p-3" 
                @click="doLogin" 
                style="font-size: 32px;width: 420px;">
          Login amb Microsoft 
          <img  src="../assets/mssymbol.svg" 
                style="margin-left: 12px;width: 30px;">
        </button>
      </div>
    </div>
    <div class="row m-4">
      <div class="col d-flex justify-content-center">
        <h5>Cal un compte de Microsoft de Fundació Claror.</h5>
      </div>
    </div>
    <div v-if="error" class="row alert alert-warning m-4 p-4" role="alert">
      <div class="col d-flex justify-content-center">
        <h3>{{ error }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '@/services/auth'

export default {
  name: 'MsLogin',
  emits: ["loginComplete"],

  data: function() {
    return {
      error: ''
    }
  },

  methods: {
    async doLogin() {
      try {
        auth.authority=`https://login.microsoftonline.com/${process.env.VUE_APP_TENANT_ID}`
        await auth.login()
        this.$emit('loginComplete')
      } catch (err) {
        this.error = err.toString()
      }
    }
  }
}
</script>

<style scoped>

</style>